export default __webpack_public_path__ + "static/media/sec-1-btm.f2eb73d3.png";